"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(require("./List"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/List/index.js
// module id = 94
// module chunks = 36573943044255 67936617089079 79611799117203